import React, { useState, useEffect, useMemo } from 'react';
// import { getAllEventDocs, postEventDocs } from '../../../../Core/Services/InternalUser/eventDocumentsService';
import ReportGijgoGrid from '../../internal/ReportsScreens/GijgoForReportsScreen';
import formatters from '../../../Core/Grid/inputFormatter';
import { SquareButton } from '../../../Core/FormInput/AppButton';
import { Grid } from '@material-ui/core';
import BreadCrumbs from '../../../Core/Controls/Breadcrumb';
import ReactDOM from 'react-dom';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import DialogComp from '../../../Core/Modal/dialogModal';
import EventDocumentsDialog from './eventDocumentsDialog';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Events', active: true },
    { name: 'Event Documents', active: true }
];
const basecolumns = [
    { field: 'action', title: 'Action', width: '5%' },
    { field: 'eventDocName', title: 'Name' },
    {
        field: 'eventDocRequiredInDays',
        title: 'Required In Days',
        align: 'right',
        // headerRenderer: formatters.ColumnHeaderAlignRight,
        // formatter: formatters.ColumnTextAlignRight,
        width: 180
    },
    {
        field: 'eventDocChase',
        title: 'Chase',
        // formatter: formatters.YesNo,
        width: 80
    },
    {
        field: 'eventDocLegal',
        title: 'Legal',
        // formatter: formatters.YesNo,
        width: 80
    }
];
const EventDocuments = () => {
    const [state, setState] = useState({
        open: false,
        showLoader: true,
        selectedRowData: {}
    });
    // const { showToastSuccess, showToastError } = useToast();

    const pullApiData = async () => {
        setState((state) => ({
            ...state,
            isReload: new Date()
        }));
    };

    const editButton = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center" justifyContent="center">
                <SquareButton
                    style={{
                        backgroundColor: '#183B68',
                        borderRadius: '20%',
                        width: '32px',
                        height: '32px',
                        textAlign: 'center',
                        padding: '0px 0px 0px 0px'
                    }}
                    onClick={() => addBtnClicked(record)}
                >
                    <EditIcon fontSize="small" style={{ color: 'white' }} />
                </SquareButton>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const addButton = (gridRef, valueList) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="center" style={{ paddingRight: '7px' }}>
                <SquareButton
                    style={{
                        backgroundColor: '#183B68',
                        borderRadius: '20%',
                        width: '32px',
                        height: '32px',
                        textAlign: 'center',
                        padding: '0px 0px 0px 0px',
                        marginLeft: '20px'
                    }}
                    onClick={() => addBtnClicked()}
                >
                    <AddIcon fontSize="small" style={{ color: 'white' }} />
                </SquareButton>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...basecolumns];
        let actionCol = tempCols.find((e) => e.field === 'action');
        if (actionCol) {
            actionCol.renderer = editButton;
        }
        return tempCols;
    }, []);

    const addBtnClicked = (row) => {
        setState((st) => ({
            ...st,
            open: true,
            title: row?.eventDocID ? 'Edit Event Document' : 'Add Event Document',
            isAdd: row?.eventDocID ? false : true,
            selectedRowData: row?.eventDocID ? row : {}
        }));
    };
    const handleClose = (res) => {
        setState((st) => ({
            ...st,
            open: false
        }));
        res && pullApiData();
    };

    return (
        <div className="report-screen-container">
            <BreadCrumbs crumbs={crumbs} />

            <ReportGijgoGrid
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                columns={columns}
                getUrl={'Eventdocs'}
                AddBtn={addButton}
                isReload={state.isReload}
            />
            {state.open ? (
                <DialogComp open={state.open} onClose={() => handleClose(false)} title={state.title} maxWidth="md">
                    <EventDocumentsDialog
                        data={state}
                        onClose={handleClose}
                        // saveData={saveData}
                    />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default EventDocuments;
